import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to hash target after route transitions to '/'
 * so nav clicks from /work/:id land at the right section.
 */
export const ScrollToHash = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (pathname === "/" && hash) {
      // wait for layout, then scroll
      requestAnimationFrame(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    } else if (!hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToHash;
